export default {
    createFromArray(array, columns){
        return array.reduce((reduced, element, index)=>{
            return (index % columns === 0 ? reduced.push([element]) : reduced[reduced.length - 1].push(element)) && reduced
        }, []);
    },
}
